'use strict';

class AddressPeaker {
    constructor(e) {
        this._e = document.getElementById(e);
    }

    bindSelectEvent(event = false) {
        if (event) {
            $(this._e).on('change', function () {
                event();
            })
        }
    }

    getSelectedOptionValue() {
        return $(this._e).val();
    }

    showAddressData(id) {
        $('div[data-state="true"]').attr('data-state', 'false').hide();
        $('div[data-address='+ id +']').attr('data-state', 'true').show();
    }

    selectAddressInPeaker(id) {
        $('select[name="address_peaker"] option[value=' + id + ']').prop('selected', true);
    }

    bildAddressPeaker(placemarks) {
        let select = $(this._e);
        select.find('option').remove();

        placemarks.forEach(function (placemark) {
           select.append($('<option></option>').attr('value', placemark.id).text(placemark.address));
        });        
    }
}

